import { Partner, PartnerRepresentant } from 'types';
import { TranslateFn } from 'hooks/useTranslate';
import { sindicationTypes } from '../constants/sindicationTypes';

type GetPartnerSindicatedTooltipProps = {
  partner: Partner;
  partnerRepresentants: PartnerRepresentant[];
  t: TranslateFn;
};

export const getPartnerSindicatedTooltip = ({
  partner,
  partnerRepresentants,
  t,
}: GetPartnerSindicatedTooltipProps) => {
  const sindicatedBy = partnerRepresentants?.find(
    (representant) => representant['_id'] === partner.sindication
  );

  if (!sindicatedBy) return null;

  return (
    <span>
      {sindicatedBy.name}{' '}
      <b>({t(partner?.sindicationType || sindicationTypes.STANDARD)})</b>
    </span>
  );
};
